import React from 'react'

import {HeadingProps} from './types'

const H2 = ({children}: HeadingProps) => {
  return (
    <h2 className="text-[24px] md:text-[26px] lg:text-[28px] xl:text-[30px] leading-8 font-bold text-kwota-subdued">
      {children}
    </h2>
  )
}

export default H2
